import { ComponentRef } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { DialogService } from "./dialog.service";

export class DialogRef<T = any> {
  public componentRef?: ComponentRef<any>;
  private readonly afterClosedSubject$ = new Subject<T | undefined>();

  constructor(private readonly dialogService: DialogService) {}

  cancel(result?: T): void {
    this.dialogService.close(this, result); // Use DialogService to close the dialog
  }

  confirm(result?: T): void {
    this.dialogService.close(this, result); // Use DialogService to close the dialog
  }

  /**
   * Returns an observable that emits when the dialog is closed.
   */
  afterClosed(): Observable<T | undefined> {
    return this.afterClosedSubject$.asObservable();
  }

  close(result?: T): void {
    // Emit the result and complete the subject
    this.afterClosedSubject$.next(result);
    this.afterClosedSubject$.complete();

    // Destroy the modal component if it exists
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}
